import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
    loading: {
        id: 'classPage.loading',
        defaultMessage: 'Loading class data...',
    },
    header: {
        id: 'classPage.header',
        defaultMessage: 'Description',
    },
});

export default messages;
